export default __webpack_public_path__ + "69a5afff8d249fa30648b272d3f2dafe.png";